import ClearAllIcon from "@material-ui/icons/ClearAll";
import TrustTypeList from "./TrustTypeList";

export default {
  list: TrustTypeList,
  icon: ClearAllIcon,
};
